function getWebkitMatrix(computedStyle) {
    return new WebKitCSSMatrix(computedStyle.webkitTransform);
}
function getTranslateX(computedStyle) {
    return getWebkitMatrix(computedStyle).m41;
}
function getTranslateY(computedStyle) {
    return getWebkitMatrix(computedStyle).m42;
}
function getScale(computedStyle, rect) {
    const matrix = getWebkitMatrix(computedStyle);
    return {
        x: (rect == null ? computedStyle.getPropertyValue('width') : rect.width) === 0 ? 0 : matrix.a,
        y: (rect == null ? computedStyle.getPropertyValue('height') : rect.height) === 0 ? 0 : matrix.d
    };
}
function getOpacity(computedStyle) {
    if (computedStyle.getPropertyValue('width') === '0px' || computedStyle.getPropertyValue('height') === '0px') {
        return 0;
    }
    const opacityString = computedStyle.getPropertyValue('opacity');
    return isNaN(+opacityString) ? 0 : Number(opacityString);
}
const HIDDEN_STYLE_MAP = {
    position: 'absolute',
    top: '0',
    left: '0',
    opacity: '0',
    margin: '0',
    padding: '0',
    width: '100%',
    height: '100%',
    cursor: 'inherit'
};

export { HIDDEN_STYLE_MAP, getOpacity, getScale, getTranslateX, getTranslateY, getWebkitMatrix };
